
    const html = "<a href tabindex=-1 ng-bind-html=\"match.label | uibTypeaheadHighlight:query\" ng-attr-title={{match.label}}></a> ";
    angular.module('ng').run(['$templateCache', function($templateCache){
      $templateCache.put('uib/template/typeahead/typeahead-match.html', html);
    }]);
    module.exports = 'uib/template/typeahead/typeahead-match.html';
  